module.exports = __webpack_public_path__ + "static/media/BS_O_Timeless_Sforza_White.bcc1e1d2.png";